import { api_host } from '../constants'

let isRefreshing = false; // Flag to indicate if a refresh is already in progress
let refreshQueue = []; // Queue to hold pending API calls

const isTokenExpired = (accessToken) => {
    if (!accessToken) return true;
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    const expiryTime = payload.exp * 1000; // Convert to milliseconds
    console.log("Expiry Time", expiryTime, Date.now(), expiryTime < Date.now())
    return expiryTime < Date.now(); // True if expired
};

const refreshAccessToken = async () => {
    const refreshToken = window.localStorage.getItem('refreshToken');
    if (!refreshToken) throw new Error('Refresh Token is missing');

    const response = await fetch(`${api_host}/auth/refresh-token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refreshToken }),
    });

    const data = await response.json();
    if (data.success) {
        window.localStorage.setItem('token', data.accessToken); // Update Access Token
        return data.accessToken;
    } else {
        throw new Error('Failed to refresh Access Token');
    }
};

const processQueue = (error, newToken = null) => {
    refreshQueue.forEach(([resolve, reject]) => {
        if (newToken) {
            resolve(newToken);
        } else {
            reject(error);
        }
    });
    refreshQueue = [];
};

export const apiFetch = async (url, options = {}) => {
    let accessToken = window.localStorage.getItem('token');

    // Refresh Access Token if expired
    if (isTokenExpired(accessToken)) {
        if (!isRefreshing) {
            isRefreshing = true;
            try {
                accessToken = await refreshAccessToken();
                processQueue(null, accessToken); // Resolve all queued requests
            } catch (err) {
                processQueue(err, null); // Reject all queued requests
                window.location.href = '/login'; // Redirect to login if refresh fails
                localStorage.clear();
                throw err;
            } finally {
                isRefreshing = false;
            }
        } else {
            // If already refreshing, queue this request
            return new Promise((resolve, reject) => {
                refreshQueue.push([resolve, reject]);
            }).then((newToken) => {
                // Use the new token once it's available
                options.headers = {
                    ...options.headers,
                    Authorization: `Bearer ${newToken}`,
                };
                return fetch(url, options).then((res) => res.json());
            });
        }
    }

    // Add Authorization header with the (refreshed) Access Token
    options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
    };

    // Make the API request
    const response = await fetch(url, options);

    // Retry on 401 if token refresh logic is needed (rare case)
    if (response.status === 401) {
        try {
            accessToken = await refreshAccessToken();
            options.headers.Authorization = `Bearer ${accessToken}`;
            return await fetch(url, options).then((res) => res.json()); // Retry the request
        } catch (err) {
            console.error('Failed to retry after refreshing token:', err.message);
            window.location.href = '/login';
            throw err;
        }
    }

    return response.json();
};
